/* eslint-disable no-unused-vars */
import { forwardRef, useEffect, useLayoutEffect, useState } from 'react';
import EmptyIcon from 'assets/images/EmptyIcon.svg';
import Spinner from 'assets/images/Spinner.svg';

const mergeCallbacks =
  (...callbacks) =>
  (...args) => {
    callbacks.filter(Boolean).forEach((callback) => callback(...args));
  };

//pass props two properties: "src" and "fallbackSrc"
const ImageWithFallback = forwardRef((props, ref) => {
  const [useFallback, setUseFallback] = useState(false);

  const src = props?.src;
  useLayoutEffect(() => {
    setUseFallback(false);
  }, [src]);

  return (
    <img
      width={props.width}
      height={props.height}
      ref={ref}
      src={useFallback ? props?.fallbackSrc ?? EmptyIcon : props.src}
      onError={mergeCallbacks(props?.onError, () => {
        setUseFallback(true);
      })}
    />
  );
});

ImageWithFallback.displayName = 'ImageWithFallback';

export default ImageWithFallback;
